// QR scan counter — B2CAPPTH-2964 Section 3, `qr_scan`.
//
// The QR on the desktop landing page used to encode a store link directly, so
// nothing we own ran between the camera and the App Store and the scan could
// not be counted at all. This page is the missing step: the QR points here, the
// scan is recorded, and the visitor is sent straight on to the store.
//
// The design says a desktop scan goes to the store, and it still does. Nobody
// reads this page — it paints a fallback link and redirects within a few
// hundred milliseconds. That fallback is not decoration: if the redirect is
// blocked or the browser restores this page from the back stack, a visitor who
// would otherwise be stranded has something to tap.
//
// Deliberately not a copy of the landing page's behaviour: it does not try the
// cpamapp:// scheme first. Someone scanning the download QR is being sent to
// install the app, and probing for an app they are unlikely to have would add
// an iOS confirm dialog to a journey whose whole point is speed.

import React, { useEffect, useState } from "react";
import { detectPlatform, getStoreUrl, parseQuery } from "../DeeplinkLanding/utils";
import { logLandingEvent } from "../DeeplinkLanding/analytics";

// How long to let the event leave before navigating away. gtag sends through
// sendBeacon when a page is unloading, which usually survives, but a navigation
// can still cancel an in-flight request — and an uncounted scan is the one
// thing this page exists to prevent. Short enough that nobody experiences it as
// a wait.
const REDIRECT_DELAY_MS = 400;

function DeeplinkQr() {
  const [storeUrl, setStoreUrl] = useState(null);

  useEffect(() => {
    const query = parseQuery();
    const platform = detectPlatform();
    const target = getStoreUrl(platform);
    setStoreUrl(target);

    // `destination` rides along so a report can tell which landing page the
    // scanned QR belonged to. It is not used for routing here: the scan goes to
    // the store either way.
    logLandingEvent("qr_scan", {
      destination: query.destination,
      platform,
      ref_id: query.ref_id,
    });

    const timer = setTimeout(() => {
      // replace, not assign: pressing Back should return to whatever the
      // visitor was doing before the camera, not bounce them through here again.
      window.location.replace(target);
    }, REDIRECT_DELAY_MS);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "12px",
        fontFamily: "'Helvetica Neue', Arial, sans-serif",
        color: "#4d5663",
        background: "#ffffff",
        padding: "24px",
        textAlign: "center",
      }}
    >
      <p style={{ margin: 0, fontSize: "15px" }}>กำลังเปิดหน้าดาวน์โหลดแอปพลิเคชัน…</p>
      {storeUrl && (
        <a href={storeUrl} style={{ color: "#0b5fa5", fontSize: "14px" }}>
          แตะที่นี่หากหน้าไม่เปลี่ยนอัตโนมัติ
        </a>
      )}
    </div>
  );
}

export default DeeplinkQr;
